import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
var _excluded = ["loading", "disabled"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { forwardRef } from 'react';
import { CircularProgress } from '@material-ui/core';
import { ButtonStyled, LinkButtonStyled } from "./styles";
import { Typography } from "../Typography";
import { COLORS } from "../../constants/colors";
import { useLinkComponent } from "../LinkProvider";

// eslint-disable-next-line react/display-name
export var Button = /*#__PURE__*/forwardRef(function (props, ref) {
  var loading = props.loading,
    disabled = props.disabled,
    muiProps = _objectWithoutProperties(props, _excluded);
  var linkComponent = useLinkComponent();
  delete muiProps.color;
  if (props.variant === 'link') {
    return /*#__PURE__*/React.createElement(LinkButtonStyled, _extends({}, muiProps, {
      size: "large",
      variant: "text"
    }), props.children);
  }
  return /*#__PURE__*/React.createElement(ButtonStyled, _extends({
    anchorRef: ref,
    colors: COLORS.button[props.variant][props.color],
    startIcon: loading ? /*#__PURE__*/React.createElement(CircularProgress, {
      color: "inherit",
      size: 20,
      "data-testid": "buttonCircularProgress"
    }) : undefined,
    component: props.href ? linkComponent : 'button',
    disabled: disabled || loading,
    py: props.size === 'large' ? 1.5 : 0.5
  }, muiProps), /*#__PURE__*/React.createElement(Typography, {
    style: {
      width: muiProps.fullWidth ? '100%' : undefined
    },
    variant: "button"
  }, props.children));
});
Button.defaultProps = {
  color: 'primary',
  size: 'large',
  variant: 'contained'
};